import useUserAlertsUnsubscribe from './useUserAlertsUnsubscribe';

export default useUserAlertsUnsubscribe;
